import { connect } from 'react-redux';
import Vis from './Vis';

export default connect(
  state => state.PricesVisState
)(Vis);



// WEBPACK FOOTER //
// ./src/modules/PricesVis/VisContainer.js